import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
@Component({
    selector: 'app-activation-date-dialog',
    templateUrl: './activation-date-dialog.component.html',
    styleUrls: ['./activation-date-dialog.component.scss']
})
export class ActivationDateDialogComponent implements OnInit, OnDestroy {
    form: FormGroup;
    readonly minActivationDate = new Date(2019, 0, 1);
    @Input() currentActivationDate: any;
    @Output() activationDateEmitter: EventEmitter<any>;
    private destroyed = new Subject<void>();

    constructor(private fb: FormBuilder) {
        this.activationDateEmitter = new EventEmitter();
        this.form = fb.group({
            activationDate: new FormControl(null, [Validators.required])
        });
        this.form.controls.activationDate.valueChanges.pipe(takeUntil(this.destroyed)).subscribe(this.activationDateEmitter);
    }

    ngOnInit(): void {
        if (this.currentActivationDate) {
            this.form.controls.activationDate.setValue(this.currentActivationDate);
        }
    }

    ngOnDestroy(): void {
        this.destroyed.next();
        this.destroyed.complete();
    }

}
